<template>
  <div class="horizontal-menu mb32">
    <h3 class="mb12 shimmer-title shimmer-container"></h3>
    <!-- without carousel -->
    <template v-if="isGridView">
      <ul class="grid-view" style="min-height:300px">
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
        <li>
          <div class="flex-column flex-wrap cursor-pointer">
            <div
              class="menu-img-wrap shimmer-category shimmer-container mb8"
            ></div>
            <span class="shimmer-container hide-shimmer-text">Veg Pizza</span>
          </div>
        </li>
      </ul>
    </template>
    <!-- with carousel -->
    <template v-else>
      <section class="carousel" dir="ltr" aria-label="Gallery" style="min-height:150px">
        <div class="carousel__viewport">
          <ol
            class="carousel__track"
            style="transform: translateX(0px); transition: all 0ms ease 0s"
          >
            <li
              class="carousel__slide carousel__slide--visible"
              style="width: 26.6667%; order: 0"
            >
              <div class="flex-column flex-wrap cursor-pointer">
                <div class="shimmer-category shimmer-container mb8"></div>
                <span class="shimmer-container hide-shimmer-text"
                  >Veg Pizza</span
                >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible"
              style="width: 26.6667%; order: 1"
            >
              <div class="flex-column flex-wrap cursor-pointer">
                <div class="shimmer-category shimmer-container mb8"></div>
                <span class="shimmer-container hide-shimmer-text"
                  >Pizza Mania</span
                >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible"
              style="width: 26.6667%; order: 2"
            >
              <div class="flex-column flex-wrap cursor-pointer">
                <div class="shimmer-category shimmer-container mb8"></div>
                <span class="shimmer-container hide-shimmer-text"
                  >Pizza Mania</span
                >
              </div>
            </li>
            <li
              class="carousel__slide carousel__slide--active carousel__slide--visible"
              style="width: 26.6667%; order: 3"
            >
              <div class="flex-column flex-wrap cursor-pointer">
                <div class="shimmer-category shimmer-container mb8"></div>
                <span class="shimmer-container hide-shimmer-text"
                  >Pizza Mania</span
                >
              </div>
            </li>
          </ol>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
export default {
  props: ["gridView"],
  data() {
    return {
      isGridView: false,
    };
  },
  mounted() {
    if (this.gridView) {
      this.isGridView = true;
    }
  },
};
</script>
